module.exports = __webpack_public_path__ + "img/kz.6592a47.svg";